import {Component, inject, OnInit, signal, WritableSignal} from '@angular/core';
import {DatePipe} from '@angular/common';
import {IAdminUserListItem, Role} from '@models/user.interface';
import {UserService} from '@services/user.service';
import {NotificationService} from '@services/frontend/notification.service';
import {httpErrorMessage} from 'app/utils/http-error.utils';

@Component({
  selector: 'app-admin-users',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './admin-users.html',
})
export class AdminUsers implements OnInit {
  private readonly userService = inject(UserService);
  private readonly notificationService = inject(NotificationService);

  users: WritableSignal<IAdminUserListItem[]> = signal([]);
  loading: WritableSignal<boolean> = signal(true);

  readonly Role = Role;

  ngOnInit() {
    this.load();
  }

  load() {
    this.loading.set(true);
    this.userService.listUsersForAdmin().subscribe({
      next: (list) => {
        this.users.set(list);
        this.loading.set(false);
      },
      error: (err) => {
        this.loading.set(false);
        this.notificationService.error(httpErrorMessage(err, 'Impossible de charger les utilisateurs.'), 4000);
      },
    });
  }

  roleLabel(role: Role): string {
    switch (role) {
      case Role.EXECUTIVE:
        return 'Entrepreneur';
      case Role.ACCOUNTANT:
        return 'Expert-comptable';
      case Role.ADMIN:
        return 'Admin (rôle legacy)';
      default:
        return role;
    }
  }
}
